module.exports = __webpack_public_path__ + "img/housekeeper2.0f997939.png";